import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { StoreState } from '@manager/reducers'
import { Box } from '@mui/material'
import { backgroundBlack } from '@common/styles'
import { MicrosoftLogin } from '@components/Button'
import LoginBox from '@components/LoginBox'
import { managerPath, toManagerRoute } from '@common/appConfig'
import {
  AccountActionType,
  getProfileAction,
  loginAction,
  logoutAction,
} from '@manager/reducers/account/accountActions'
import { MSAL_MANAGER_OAUTH } from '@src/common/constants'
import { toMsalCode } from '@src/utils/function'
import { useLoading } from '@src/hooks'
import GlobalDialog from '@src/components/GlobalDialog'
import messages from '@src/common/messages'
import { useIntl } from 'react-intl'

export default function Login() {
  const dispatch = useDispatch()
  const { formatMessage: f } = useIntl()
  const { isLogin } = useSelector(
    (state: StoreState) => ({
      isLogin: !!state.account.token,
    }),
    shallowEqual
  )
  const navigate = useNavigate()
  const { openSpinner } = useLoading({
    endActions: {
      success: [AccountActionType.GET_PROFILE_SUCCESS],
      error: [AccountActionType.GET_PROFILE_ERROR],
    },
    cbk: {
      success: () => {
        navigate(toManagerRoute(managerPath.agencyList.list))
      },
      error: () => {
        GlobalDialog.open({
          content: f(messages.expired),
          closeText: f(messages.confirm),
          onClose: () => {
            dispatch(logoutAction())
          },
        })
      },
    },
  })
  const code = toMsalCode(window.location.hash)

  useEffect(() => {
    if (!!code) {
      dispatch(loginAction(code))
    }
  }, [dispatch, code])

  useEffect(() => {
    if (isLogin) {
      openSpinner()
      dispatch(getProfileAction())
    }
  }, [dispatch, code, isLogin, openSpinner])

  return (
    <Box
      height="100vh"
      bgcolor={backgroundBlack}
      display="flex"
      alignItems="center">
      <LoginBox title="Manager">
        <Box textAlign="center">
          <MicrosoftLogin msalOAth={MSAL_MANAGER_OAUTH} />
        </Box>
      </LoginBox>
    </Box>
  )
}
